
import './flycard.css'
function Fly() {
    return (
        <div >
              <div className="container">
            <div className="card">
                <div className="content">
                    {/* <h2>1</h2> */}
                    <p className="styy">Web Designing</p>
                 
                </div>
            </div>
            <div className="card">
                <div className="content">
                <p className="styy">Web Development</p>
                </div>
            </div>
            <div className="card">
                <div className="content">
                <p className="styy">Web App</p>
                </div>
            </div>
            <div className="card">
                <div className="content">
                <p className="styy">Mobile App</p>
                </div>
            </div>
        </div>
        </div>
      
    )
}
export default Fly

